export default {"src":"/_next/static/media/on-boarding-step-one-image.80fd90d8.svg","height":152,"width":157,"blurWidth":0,"blurHeight":0};